module.exports = __webpack_public_path__ + "static/media/angry2.f02b5add.gif";